import { render, staticRenderFns } from "./GGEPCCMF.vue?vue&type=template&id=5352dd1d&scoped=true"
import script from "./GGEPCCMF.vue?vue&type=script&lang=js"
export * from "./GGEPCCMF.vue?vue&type=script&lang=js"
import style0 from "./GGEPCCMF.vue?vue&type=style&index=0&id=5352dd1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352dd1d",
  null
  
)

export default component.exports